export const sortTable = (tableId, n) => {
    var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
    table = document.getElementById(tableId);
    switching = true;
    dir = "asc";
    while (switching) {
        switching = false;
        rows = table.rows;
        for (i = 1; i < (rows.length - 1); i++) {
            shouldSwitch = false;
            x = rows[i].getElementsByTagName("TD")[n];
            y = rows[i + 1].getElementsByTagName("TD")[n];
            if (dir === "asc") {
                if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                    shouldSwitch = true;
                    break;
                }
            } else if (dir === "desc") {
                if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                    shouldSwitch = true;
                    break;
                }
            }
        }
        if (shouldSwitch) {
            rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
            switching = true;
            switchcount++;
        } else {
            if (switchcount === 0 && dir === "asc") {
                dir = "desc";
                switching = true;
            }
        }
    }
}

export const copyTableToClipboard = () => {
    var urlField = document.getElementById('adminTable');
    var range = document.createRange();
    range.selectNode(urlField);
    window.getSelection().addRange(range);
    document.execCommand('copy');
    alert('Copiado en portapapeles')
}

export const filterPartner = (partner, filter) => {
    return (
        partner?.firstname.toLowerCase().includes(filter.toLowerCase()) |
        partner?.lastname.toLowerCase().includes(filter.toLowerCase()) |
        partner?.email.toLowerCase().includes(filter.toLowerCase()) |
        partner?.tlf.toLowerCase().includes(filter.toLowerCase()) |
        partner?.dni.toLowerCase().includes(filter.toLowerCase())
    )
}

export const filterInvitation = (invitation, filter) => {
    if (!invitation?.name | !invitation?.email | !invitation?.type) return false
    return (
        invitation?.name.toLowerCase().includes(filter.toLowerCase()) |
        invitation?.email.toLowerCase().includes(filter.toLowerCase()) | 
        invitation?.type.toLowerCase().includes(filter.toLowerCase()) 
    )
}

export const filterApplication = (application, filter) => {
    return (
        application?.firstname.toLowerCase().includes(filter.toLowerCase()) |
        application?.lastname.toLowerCase().includes(filter.toLowerCase()) |
        application?.email.toLowerCase().includes(filter.toLowerCase()) |
        application?.contact.toLowerCase().includes(filter.toLowerCase()) |
        application?.type.toLowerCase().includes(filter.toLowerCase())
    )
}

export const filterEvent = (event, filter) => {
    return (
        event?.name.toLowerCase().includes(filter.toLowerCase())
    )
}

export const filterPromo = (promo, filter) => {
    return (
        promo?.name.toLowerCase().includes(filter.toLowerCase()) |
        promo?.code.toLowerCase().includes(filter.toLowerCase())
    )
}